<template>
  <div class="text-center">
    <v-dialog v-model="dialog" width="600">
      <template v-slot:activator="{ on, attrs }">
        <v-btn dark text small v-bind="attrs" v-on="on">
          <v-icon>more_vert</v-icon>
        </v-btn>
      </template>

      <v-card>
        <v-card-title class="headline grey lighten-2">{{ $t('rooms.modals.settings') }}</v-card-title>
        <div class="flex">
          <v-card-text class="col-50">
            <p class="col-title my-4">{{ $t('rooms.modals.copy') }}</p>
            <div class="center-email pa-4">
              <CopyClipboardButton copyFrom="Live" :copy="link" />
            </div>
          </v-card-text>
          <v-card-text v-if="authenticated && accessEmailOptions" class="col-50">
            <p class="col-title my-4">{{ $t('rooms.modals.email') }}</p>
            <div class="center-email pa-4">
              <v-btn text class="button-item" @click.stop="openSendEmailDialog">
                <v-icon>mail_outline</v-icon>
              </v-btn>
            </div>
            <SendEmailDialog
              v-model="showScheduleForm"
              from="Live"
              :username="username"
              :userEmail="userEmail"
              :initialObjectValue="objectValue"
              :initialText="initialText"
              :videoId="roomInformation.id_live_video"
            >
            </SendEmailDialog>
          </v-card-text>
        </div>

        <v-divider></v-divider>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="primary" text @click="dialog = false">OK</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import SendEmailDialog from '@/components/SendEmailDialog.vue'
import CopyClipboardButton from '@/components/buttons/CopyClipboardButton.vue'
import moment from 'moment'
import { mapState, mapGetters } from 'vuex'

export default {
  name: 'SelectModalOptions',

  props: {
    roomInformation: Object,
    authenticated: Boolean
  },

  components: {
    CopyClipboardButton,
    SendEmailDialog
  },

  data() {
    return {
      dialog: false,
      showScheduleForm: false,
      loadUrl: false,
      show: false,
      objectValue: '',
      disabled: true,
      initialText: ''
    }
  },

  methods: {
    async openSendEmailDialog() {
      this.initForm()
      this.showScheduleForm = true
    },
    initForm() {
      this.objectValue = this.$t('rooms.email.object')

      const space = '\n\n'
      const backspace = '\n'
      const headMessage = this.$t('rooms.email.headMessage')
      const bodyMessage = this.$t('rooms.email.body')
      const bodyMessage2 = this.$t('rooms.email.body2')
      const endMessage = this.$t('rooms.email.endMessage')
      const date = this.$t('rooms.email.date') + this.date
      const hour = this.$t('rooms.email.heure') + this.hour
      const url = this.link

      this.initialText =
        headMessage +
        space +
        bodyMessage +
        backspace +
        date +
        backspace +
        hour +
        space +
        bodyMessage2 +
        backspace +
        url +
        space +
        endMessage
    }
  },

  computed: {
    ...mapGetters(['username', 'userEmail']),
    ...mapState({
      userOptions: state => state.userOptions
    }),
    accessEmailOptions() {
      const useStampothequeEmailAccess =
        this.userOptions && this.userOptions.find(el => el.name === 'useStampothequeEmail')

      return (useStampothequeEmailAccess && useStampothequeEmailAccess.value) || false
    },
    date() {
      const locale = this.$i18n.locale

      return moment(this.roomInformation.appointment_date)
        .locale(locale)
        .format('dddd Do MMMM, YYYY')
    },
    hour() {
      const date = moment
        .utc(this.roomInformation.appointment_date)
        .local()
        .format('HH:mm')

      return date
    },
    link() {
      return document.location.origin + '/videos/live/rooms/' + this.roomInformation.id_live_video
    }
  }
}
</script>

<style lang="sass" scoped>
.flex
  display: flex
.col-50
  width: 50%
.col-title
  text-align: center
  font-size: 18px
.center-email
  display: flex
  justify-content: center
</style>
